/**
 * DocsLoader — centered "grid of lights" loading animation.
 *
 * Visual: a 5x5 lattice of champagne dots. A diagonal wave of brightness
 * propagates from top-left to bottom-right, then loops. Stagger is computed
 * per dot via `--i = row + column` so the animation is purely CSS.
 *
 * Always rendered in a min-height container that matches the article body
 * dimensions, so the surrounding layout doesn't collapse during loading.
 */
export function DocsLoader({ isLight = false }) {
  const ROWS = 5;
  const COLS = 5;
  const cells = [];
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      cells.push({ r, c, i: r + c });
    }
  }
  const captionColor = isLight ? "text-aubergine/60" : "text-bone/55";

  return (
    <div
      className="flex flex-col items-center justify-center min-h-[60vh] gap-8"
      data-testid="docs-page-loading"
      role="status"
      aria-label="Loading documentation"
    >
      <div
        className="grid gap-3.5"
        style={{ gridTemplateColumns: `repeat(${COLS}, minmax(0, 1fr))` }}
        aria-hidden="true"
      >
        {cells.map(({ r, c, i }) => (
          <span
            key={`${r}-${c}`}
            className="docs-loader-dot block h-2 w-2 rounded-full bg-champagne"
            style={{ "--i": i }}
          />
        ))}
      </div>
      <p className={`docs-loader-caption font-mono text-[10px] uppercase tracking-[0.25em] ${captionColor}`}>
        Loading
      </p>
    </div>
  );
}
